import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  noUser: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.main,
    paddingTop: theme.spacing(7),
    fontSize: 18,
  },
}));

export default useStyles;
